module.exports = __webpack_public_path__ + "img/maintenance-mode.b86519de.png";